import React from 'react'
import DeliverySelect from '../utils/DeliverySelect'
import BudgetSelect from '../utils/BudgetSelect'
import SortBy from '../utils/SortBy'
import Keywords from '../utils/Keywords'

const Actions = () => {
    return (
        <div className="md:flex items-center grid grid-cols-3 gap-3 mb-4">

            <BudgetSelect />
            <Keywords />
            <SortBy />
            <DeliverySelect />

        </div>
    )
}

export default Actions